import { useRef } from "react";
import { useMutation } from "react-query";
import { commitFile as commitFileQuery } from "../../../../../queries/files";
import useNetworkHeaders from "../../../../../hooks/useNetworkHeaders";

/**
 * Handles rich text editor media files. Pass addMediaFile to the editor and call commitMediaFiles on form submit.
 */
export const useEditorMedia = () => {
  const mediaFiles = useRef<string[]>([]);
  const headers = useNetworkHeaders();
  const [commitFile] = useMutation(commitFileQuery(headers));

  return {
    addMediaFile: (uuid: string) => mediaFiles.current.push(uuid),
    commitMediaFiles: async () => {
      if (!mediaFiles.current.length) return;
      await commitFile(mediaFiles.current);
    },
  };
};
